<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="videoWrap preview" :class="{ playing: isPlaying }">
    <i :class="previewIcon"></i>
    <span v-if="isPreview" class="preview-media-badge">{{ statusText }}</span>
  </div>
</template>

<script>
import previewMediaMixin from "@/utils/previewMediaMixin";

export default {
  mixins: [previewMediaMixin],
  props: {
    element: {
      type: Object,
      default: () => ({}),
    },
    isPreview: Boolean,
  },
  data() {
    return {
      status: "idle",
      muted: false,
      volume: 50,
      cueTimers: [],
    };
  },
  computed: {
    isPlaying() {
      return this.status === "play" || this.status === "continue";
    },
    previewIcon() {
      if (this.status === "pause") {
        return "el-icon-video-pause";
      }
      if (this.status === "stop" || this.status === "idle") {
        return "el-icon-video-play";
      }
      return "el-icon-video-play";
    },
    statusText() {
      if (this.muted) {
        return "静音";
      }
      const map = {
        idle: "待机",
        play: "播放中",
        pause: "已暂停",
        continue: "播放中",
        stop: "已停止",
        replay: "重播",
      };
      return map[this.status] || this.status;
    },
  },
  beforeDestroy() {
    this.clearCueTimers();
  },
  methods: {
    clearCueTimers() {
      this.cueTimers.forEach((t) => clearTimeout(t));
      this.cueTimers = [];
    },
    startCueTimers() {
      this.clearCueTimers();
      const datas =
        (this.element.events && this.element.events.instructionDatas) || [];
      datas.forEach((item) => {
        const sec = Number(item.time) || 0;
        const names = (item.instructions || [])
          .map((d) => d.instruction_name || d.name)
          .filter(Boolean)
          .join("、");
        const timer = setTimeout(() => {
          this.$message.info(
            `视频播放至 ${sec} 秒${names ? "，触发指令：" + names : ""}（预览不真实下发）`
          );
        }, sec * 1000);
        this.cueTimers.push(timer);
      });
    },
    handlePreviewMediaEvent(event) {
      switch (event) {
        case "play":
          this.status = "play";
          this.startCueTimers();
          break;
        case "pause":
          this.status = "pause";
          this.clearCueTimers();
          break;
        case "continue":
          this.status = "continue";
          this.startCueTimers();
          break;
        case "stop":
          this.status = "stop";
          this.clearCueTimers();
          break;
        case "replay":
          this.status = "play";
          this.startCueTimers();
          break;
        case "volumeUp":
          this.volume = Math.min(100, this.volume + 10);
          this.$message.success(`音量 ${this.volume}`);
          break;
        case "volumeDown":
          this.volume = Math.max(0, this.volume - 10);
          this.$message.success(`音量 ${this.volume}`);
          break;
        case "mute":
          this.muted = true;
          break;
        case "unmute":
          this.muted = false;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.videoWrap {
  width: 100%;
  height: 100%;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &.playing {
    color: #409eff;
  }
}
.preview-media-badge {
  position: absolute;
  right: 6px;
  bottom: 6px;
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 12px;
  line-height: 1.4;
  pointer-events: none;
}
</style>
